import React from "react";
import { Facebook, Twitter, Linkedin, Mail } from 'react-feather';
import { colors } from "../styles";
import styled from 'styled-components';


export const SocialIcons = ({ space, insight }) => {
  const handleClick = (site, url, space) => {
    if (url === 'email') {
      window.location.href = space ? `mailto:?subject=${insight.metaTitle}&amp;body=Check out this insight: https://www.credera.com/${space}/insights/${insight.slug}` : `mailto:?subject=${insight.metaTitle}&amp;body=Check out this insight: https://www.credera.com/insights/${insight.slug}`
    } else {
      window.open(url, "myWindow", "status = 1, height = 400, width = 500, resizable = 0, left=10000")
    }
  }

  return (
    <SocialIconsContainer>
      <SocialButton title="Share on LinkedIn" onClick={() => handleClick('linkedIn', space ? `https://www.linkedin.com/shareArticle?mini=true&url=https://www.credera.com/${space}/insights/${insight.slug}` : `https://www.linkedin.com/shareArticle?mini=true&url=https://www.credera.com/insights/${insight.slug}`)}>
        <Linkedin fill={colors.pureWhite} strokeWidth="0" />
      </SocialButton>          
      <SocialButton title="Share on Twitter" onClick={() => handleClick('twitter', space ? `https://www.twitter.com/intent/tweet?url=https://www.credera.com/${space}/insights/${insight.slug}` : `https://www.twitter.com/intent/tweet?url=https://www.credera.com/insights/${insight.slug}`)}>
        <Twitter fill={colors.pureWhite} strokeWidth="0" />
      </SocialButton>          
      <SocialButton  title="Share on Facebook" onClick={() => handleClick('facebook', space ? `https://www.facebook.com/share.php?u=https://www.credera.com/${space}/insights/${insight.slug}` : `https://www.facebook.com/share.php?u=https://www.credera.com/insights/${insight.slug}`)}>
        <Facebook fill={colors.pureWhite} strokeWidth="0" />
      </SocialButton>            
      <SocialButton title="Email article" onClick={() => handleClick('email', 'email', space)}>
        <Mail fill={colors.pureWhite} strokeWidth="1" stroke={colors.oceanBlue}/>
      </SocialButton>
    </SocialIconsContainer>
  )
}

const SocialButton = styled.button`
	color: inherit;
	border: none;
	padding: 0;
  background-color: ${colors.oceanBlue};
  border-radius: 50%;
  height: 30px;
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:hover {
    opacity: 80%;
  }
`

const SocialIconsContainer = styled.div`
  display: flex;
  width: 175px;
  justify-content: space-between;
  margin-right: 4%;
`;
